import React, { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import { useDispatch } from 'react-redux'; // useSelector, 
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, message, Row, Col } from 'antd';
import { AddUser } from '../style';
import { setExPoCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { DealUpdate } from '../../../Api/Services/DealApiService';
import { convertCurrency } from '../Filters/FilterConditions'; // ExchangeCurrency
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import CommonFormFields from '../CustomizeUi/DynamicFieldGroup';

// const { Option } = Select;

export const dealFieldConfig = {
    actualCloserDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" && sharedProps?.dealTypeField?.toLowerCase() !== "empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
        disabledDate: sharedProps.disabledDate,
    }),
    dealHoldDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "onhold" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
        dependsOn: ["dealRestartDate"],
        validationType: "dateBefore",
        disabledDate: sharedProps.disabledDate,
    }),
    dealRestartDate: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
        dependsOn: ["dealHoldDate"],
        validationType: "dateAfter",
        disabledDate: sharedProps.disabledDate,
    }),
    dealLostDate: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "lost" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "lost",
        disabledDate: sharedProps.disabledDate,
    }),
    actualDealMargin: (sharedProps) => ({
        required: sharedProps?.pipeLineField?.toLowerCase() === "won" && sharedProps?.dealTypeField !== "Empanelment",
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
    }),
    dealWonReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "won",
    }),
    dealHoldReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "onhold",
    }),
    dealLostReason: (sharedProps) => ({
        required: false,
        disabled: sharedProps?.pipeLineField?.toLowerCase() !== "lost",
    }),
};

const Popup = ({ Popup, setPopup, GetCallback, filteredGruop, customFields, optionsMap, popupType, Id, pipeline, dealTypes, ApprovalMessage, AutomationMessage, dealDataSet, dealInitialDataset, defaultCurrency, successMessage, setErrorData, setIsModalVisible1 }) => { // old // pipelineId
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    // const localData = useSelector((state) => state.localRedux);
    // const ProfileData = localData.profile
    // const profile = ProfileData
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [pipeLineField, setPipeLineField] = useState()
    // const [changeDealMargin2, setChangeDealMargin2] = useState()
    const [overAllData, setOverAllData] = useState()
    const [disabled, setDisabled] = useState(false);
    const [dealTypeField, setDealTypeField] = useState()
    const ConvertRate = defaultCurrency?.exchangeRate;
    // const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    // const [totalSumValues, setTotalSumValues] = useState({
    //     dealValue: 0,
    //     grossdealValue: 0,
    //     forecastedValue: 0,
    //     dealprofit: 0
    // })
    // function extractTimeZoneName(tzString) {
    //     const parts = tzString.split(" ");
    //     return parts[1];
    // }
    // const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    // const tz = extractTimeZoneName(tzString);
    // const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    // const currentDate = new Date(currentrealTime);
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const groupMap = {
        won: "dealWonInformation",
        lost: "DealLostInformation",
        onhold: "dealon-HoldInformation",
    };
    const selectedGroup = filteredGruop.filter(
        item => item.value === groupMap[pipeline]
    );
    const attributes = filteredGruop.flatMap(
        group => customFields[group.customFieldGroupId] || []
    );
    // const formattedCurrentDate = currentDate.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
    // const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    // const isFormDataValid = formDatas.every(formData => {
    //     return requiredFields.every(field => {
    //         const value = formData[field];
    //         return value !== undefined && value !== '';
    //     });
    // });
    // const isservicesDataValid = servicesData.every(formData => {
    //     return Object.values(formData).every(value => value !== undefined && value !== '');
    // });
    // const isroleDataValid = roleData.every(formData => {
    //     return Object.values(formData).every(value => value !== undefined && value !== '');
    // });
    // const RequiredDateFormating = (dateString) => {
    //     if (dateString) {
    //         const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
    //         const formattedDate = parsedDate.format("YYYY-MM-DD");
    //         return formattedDate;
    //     }
    //     return null;
    // }
    // const getPipelineStage = async () => {
    //     if (popupType === "Update") {
    //         setPipeLineField(pipeline)
    //     }
    //     else {
    //         try {
    //             const data = await FetchAllPipeline()
    //             setPipeLineField(data[0].pipelineStageName)
    //         }
    //         catch (error) {
    //             message.error(error)
    //         }
    //     }
    // };
    // async function DealWonApi() {
    //     try {
    //         const data = await wonReasonApi()
    //         const options = data.map((option, i) => (
    //             <Option value={option.dealWonReasonId} key={i} >
    //                 {option.dealWonReasonName}
    //             </Option>));
    //         setDealWon(options)
    //     }
    //     catch (error) {
    //         message.error(error)
    //     }
    // }
    // async function DealLoseApi() {
    //     try {
    //         const data = await LostReasonApi()
    //         const options = data.map((option, i) => (
    //             <Option value={option.dealLostReasonId} key={i} >
    //                 {option.dealLostReasonName}
    //             </Option>));
    //         setDealLose(options)
    //     }
    //     catch (error) {
    //         message.error(error)
    //     }
    // }
    // async function DealOnHoldApi() {
    //     try {
    //         const data = await HoldReasonapi()
    //         const options = data.map((option, i) => (
    //             <Option value={option.dealHoldReasonId} key={i} >
    //                 {option.dealOnHoldReasonName}
    //             </Option>));
    //         setDealOnHold(options)
    //     }
    //     catch (error) {
    //         message.error(error)
    //     }
    // }
    // const actualclosuredateChange = (date, dateString) => {
    //     const formattedDate = RequiredDateFormating(dateString)
    //     setActualclosureDate(formattedDate);
    // };
    // const dealLostDateChange = (date, dateString) => {
    //     const formattedDate = RequiredDateFormating(dateString)
    //     setDealLostDate(formattedDate);
    // };
    // const dealonholdDateChange = (date, dateString) => {
    //     const formattedDate = RequiredDateFormating(dateString)
    //     setDealonholdDate(formattedDate);
    // };
    // const dealrestartDateChange = (date, dateString) => {
    //     const formattedDate = RequiredDateFormating(dateString)
    //     setDealrestartDate(formattedDate);
    // };
    const handleClose = () => {
        if (popupType === "Update") {
            setPopup(false)
            GetCallback()
        }
        else {
            setPopup(false)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        let hideMessage;
        setDisabled(true)
        const {
            //     deallostReasons,
            //     dealWonreasons,
            //     dealonHoldReason,
            actualDealMargin,
        } = values;
        try {
            if (popupType === "Update") {
                hideMessage = message.loading("Loading...", 0);
                // const DealV = totalSumValues?.dealValue
                //     ? await convertCurrency(ConvertRate, Number(totalSumValues?.dealValue))
                //     : totalSumValues?.dealValue;
                // const ProfitV = totalSumValues?.dealprofit
                //     ? await convertCurrency(ConvertRate, Number(totalSumValues?.dealprofit))
                //     : totalSumValues?.dealprofit;
                // const GrossDealV = totalSumValues?.grossdealValue
                //     ? await convertCurrency(ConvertRate, Number(totalSumValues?.grossdealValue))
                //     : totalSumValues?.grossdealValue;
                // const ForecastedV = totalSumValues?.forecastedValue
                //     ? await convertCurrency(ConvertRate, Number(totalSumValues?.forecastedValue))
                //     : totalSumValues?.forecastedValue;
                // const convertedServicesData = await Promise.all(
                //     servicesData.map(async (service) => {
                //         const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                //             convertCurrency(ConvertRate, Number(service.serviceLineCost))
                //             : service.serviceLineCost
                //         );
                //         return {
                //             ...service,
                //             serviceLineCost: convertedCost?.toString(),
                //         };
                //     })
                // );
                // const convertedRoleData = await Promise.all(
                //     roleData.map(async (role) => {
                //         const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                //             ? convertCurrency(ConvertRate, Number(role.rolePerDayRate))
                //             : role.rolePerDayRate);
                //         const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== "" ?
                //             convertCurrency(ConvertRate, Number(role.totalValue))
                //             : role.totalValue);
                //         return {
                //             ...role,
                //             rolePerDayRate: convertedRate?.toString(),
                //             totalValue: convertedTotalValue?.toString(),
                //         };
                //     })
                // );
                // const convertedFormDatas = await Promise.all(
                //     formDatas.map(async (product) => {
                //         const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                //             ? convertCurrency(ConvertRate, Number(product.productLicenseSellingPriceUnitMonth))
                //             : product.productLicenseSellingPriceUnitMonth);
                //         // const convertedSubtotal = await (product.subtotal !== undefined && product.subtotal !== '' && product.subtotal !== null
                //         //     ? convertCurrency(ConvertRate, Number(product.subtotal))
                //         //     : product.subtotal);
                //         const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                //             ? convertCurrency(ConvertRate, Number(product.total))
                //             : product.total);
                //         // let convertedAdjustments = product.adjustments;
                //         // if (product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustmentType !== "%") {
                //         //     convertedAdjustments = await convertCurrency(ConvertRate, Number(product.adjustments))
                //         // }
                //         return {
                //             ...product,
                //             productLicenseSellingPriceUnitMonth: convertedPrice?.toString(),
                //             // subtotal: convertedSubtotal,
                //             total: convertedTotal?.toString(),
                //             // adjustments: product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null ? convertedAdjustments : product.adjustments,
                //         };
                //     })
                // );
                const currentStructure = await Promise.all(
                    attributes.map(async (field) => {
                        let value;
                        switch (field.fieldType) {
                            // case 'FileUpload':
                            //     value = normalizeValue(images[field.fieldKey] ?? null);
                            //     break;
                            // case 'MultiFileUpload':
                            //     value = fileLists[field.fieldKey] || [];
                            //     break;
                            case 'Date':
                                value = values[field.fieldKey]
                                    ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                                    : null;
                                break;
                            case 'Number':
                                // string → number or null
                                value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                                    ? Number(values[field.fieldKey])
                                    : null;
                                break;
                            case 'Percentage':
                                // string → number or null
                                value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                                    ? Number(values[field.fieldKey])
                                    : null;
                                break;
                            case 'Currency':
                                value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                                    ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                                    : null;
                                break;
                            case 'Multi-Dropdown':
                                value = values[field.fieldKey] && values[field.fieldKey].length > 0
                                    ? values[field.fieldKey].join(",")
                                    : null;
                                break;
                            case 'CheckBox':
                                value = values[field.fieldKey] ?? false;
                                break;
                            default:
                                value = normalizeValue(values[field.fieldKey] ?? null);
                                break;
                        }
                        return { ...field, value };
                    })
                );
                const attributeValues = currentStructure.reduce((acc, field) => {
                    acc[field.fieldKey] = field.value;
                    return acc;
                }, {});
                const formData = {
                    ...overAllData,
                    // dealValue: DealV,
                    // dealProfit: ProfitV,
                    // grossDealValue: GrossDealV,
                    // forecastedValue: ForecastedV,
                    // products: convertedFormDatas,
                    // services: convertedServicesData,
                    // staffRole: convertedRoleData,
                    expectedDealLength: pipeLineField === "won" ? actualDealMargin : overAllData.expectedDealLength,
                    ...attributeValues,
                }
                // if (pipeLineField === "won") {
                //     formData.dealWonReason = normalizeValue(dealWonreasons);
                //     formData.actualCloserDate = normalizeValue(actualclosureDate);
                //     formData.actualDealMargin = normalizeValue((actualDealMargin && actualDealMargin !== "") ? Number(actualDealMargin) : undefined)
                // } else { formData.dealWonReason = null; formData.actualCloserDate = null; formData.actualDealMargin = null; }
                // if (pipeLineField === "lost") {
                //     formData.dealLostReason = normalizeValue(deallostReasons);
                //     formData.dealLostDate = normalizeValue(dealLostDate);
                // }
                // else { formData.dealLostReason = null; formData.dealLostDate = null; }
                // if (pipeLineField === "onhold") {
                //     formData.dealHoldReason = normalizeValue(dealonHoldReason);
                //     formData.dealHoldDate = normalizeValue(dealonholdDate);
                //     formData.dealRestartDate = normalizeValue(dealrestartDate);
                // }
                // else { formData.dealHoldReason = null; formData.dealHoldDate = null; formData.dealRestartDate = null; }
                const changedFields = getChangedFields(formData, dealInitialDataset);
                const defaultChanges = {};
                const customFieldValues = [];
                Object.entries(changedFields).forEach(([fieldKey, value]) => {
                    const field = currentStructure.find(
                        item => item.fieldKey === fieldKey
                    );
                    if (!field) {
                        defaultChanges[fieldKey] = value;
                        return;
                    }
                    if (field.customFieldType === "Default") {
                        defaultChanges[fieldKey] = value;
                    } else {
                        customFieldValues.push({
                            entityId: field.entityId,
                            fieldId: field.fieldId,
                            value,
                        });
                    }
                });
                const payload = {
                    ...defaultChanges,
                    ...(customFieldValues.length > 0 && { customFieldValues }),
                };
                try {
                    const response = await DealUpdate(payload, Id)
                    if (response.status === 200) {
                        if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                            setErrorData(response.data);
                            setIsModalVisible1(true);
                            loadingRef.current = false;
                            setDelteClick(false)
                        }
                        else {
                            // eslint-disable-next-line no-lonely-if
                            if (response.data[0].message === AutomationMessage) {
                                if (pipeLineField === "won") {
                                    dispatch(setExPoCall(true));
                                    successMessage("Automation rule triggered", response.data[0].message)
                                    setTimeout(() => {
                                        dispatch(setExPoCall(false));
                                    }, 3000);
                                } else {
                                    successMessage("Automation rule triggered", response.data[0].message)
                                }
                            }
                            else if (response.data[0].message === ApprovalMessage) {
                                successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            }
                            else if (response.data[0].message !== ApprovalMessage && response.data[0].message !== AutomationMessage) {
                                if (pipeLineField === "won") {
                                    dispatch(setExPoCall(true));
                                    successMessage("Deal Won", <>
                                        <img
                                            src={require('../../../static/img/defaultImages/Won.gif')}
                                            alt="celebration"
                                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                        />
                                        <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                                    </>)
                                    setTimeout(() => {
                                        dispatch(setExPoCall(false));
                                    }, 3000);
                                } else {
                                    message.success("Deal pipeline updated successful");
                                }
                            } else {
                                message.success("Deal pipeline updated successful");
                            }
                            loadingRef.current = false;
                            setDelteClick(false)
                        }
                        GetCallback()
                        hideMessage();
                        setPopup(false)
                    }
                } catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    hideMessage();
                    message.error(error)
                }
            }
        } catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    // const fetchAll = async () => {
    //     await Promise.allSettled([
    //         getPipelineStage(),
    //         DealLoseApi(),
    //         DealOnHoldApi(),
    //         DealWonApi(),])
    // };
    // useEffect(() => {
    //     form.setFieldsValue({
    //         actualclosureDate: moment(formattedCurrentDate),
    //         dealLostDate: moment(formattedCurrentDate),
    //         dealHoldDate: moment(formattedCurrentDate),
    //         dealRestartDate: moment(formattedCurrentDate),
    //     })
    //     setActualclosureDate(formattedCurrentDate)
    //     setDealLostDate(formattedCurrentDate)
    //     setDealonholdDate(formattedCurrentDate)
    //     setDealrestartDate(formattedCurrentDate)
    //     fetchAll()
    // }, [])
    async function setDealCalculation(params) {
        // const DealValue = params.dealValue ? await ExchangeCurrency(Number(params.dealValue), ConvertRate) : params.dealValue;
        // const ProfitDealValue = params.dealProfit && params.dealProfit !== "" ? await ExchangeCurrency(Number(params.dealProfit), ConvertRate) : params.dealProfit;
        // const GrossDealValue = params.grossDealValue ? await ExchangeCurrency(Number(params.grossDealValue), ConvertRate) : params.grossDealValue;
        // const ForecastedValue = params.forecastedValue ? await ExchangeCurrency(Number(params.forecastedValue), ConvertRate) : params.forecastedValue;
        // const convertedServicesData = await Promise.all(
        //     params.services.map(async (service) => {
        //         const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
        //             ExchangeCurrency(Number(service.serviceLineCost), ConvertRate)
        //             : service.serviceLineCost
        //         );
        //         return {
        //             ...service,
        //             serviceLineCost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
        //         };
        //     })
        // );
        // const convertedFormDatas = await Promise.all(
        //     params.products.map(async (product) => {
        //         const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
        //             ? ExchangeCurrency(Number(product.productLicenseSellingPriceUnitMonth), ConvertRate)
        //             : product.productLicenseSellingPriceUnitMonth);
        //         // const convertedSubtotal = await (product.subtotal !== undefined && product.subtotal !== '' && product.subtotal !== null
        //         //     ? ExchangeCurrency(Number(product.subtotal), ConvertRate)
        //         //     : product.subtotal);
        //         const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
        //             ? ExchangeCurrency(Number(product.total), ConvertRate)
        //             : product.total)
        //         return {
        //             ...product,
        //             productLicenseSellingPriceUnitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
        //             total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
        //         };
        //     })
        // );
        // const convertedRoleData = await Promise.all(
        //     params.staffRole.map(async (role) => {
        //         const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
        //             ? ExchangeCurrency(Number(role.rolePerDayRate), ConvertRate)
        //             : role.rolePerDayRate);
        //         const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== ""
        //             ? ExchangeCurrency(Number(role.totalValue), ConvertRate)
        //             : role.totalValue);
        //         return {
        //             ...role,
        //             rolePerDayRate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
        //             totalValue: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
        //         };
        //     })
        // );
        // setRoleData(convertedRoleData)
        // setServiceData(convertedServicesData)
        // setFormDatas(convertedFormDatas)
        const updatedPerson = {
            ...params,
            // grossDealValue: Number(GrossDealValue?.toFixed(CurencyDecimalPlace)),
            // dealProfit: Number(ProfitDealValue?.toFixed(CurencyDecimalPlace)),
            // dealValue: Number(DealValue?.toFixed(CurencyDecimalPlace)),
            // forecastedValue: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
        };
        form.setFieldsValue({
            actualDealMargin: params.actualDealMargin !== undefined && params.actualDealMargin !== null && params.actualDealMargin !== "" ? params.actualDealMargin : params.expectedDealLength,
        })
        setDealTypeField(dealTypes)
        setPipeLineField(pipeline)
        setOverAllData(updatedPerson)
        // setChangeDealMargin2(params.actualDealMargin !== undefined && params.actualDealMargin !== null && params.actualDealMargin !== "" ? params.actualDealMargin : params.expectedDealLength)
    }
    // function totalCalculation() {
    //     const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    //     const dealValues = overAllData?.grossDealValue || 0
    //     let sum = 0;
    //     let totalsum = 0;
    //     let Fvalue = 0;
    //     let profit = 0;
    //     if (overAllData?.subtype === "Product and Services" || overAllData?.subtype === "Request for Proposal" || overAllData?.subtype === "Others") {
    //         if (isFormDataValid || isservicesDataValid) {
    //             if (formDatas.length === 0 && servicesData.length === 0) {
    //                 sum = 1 * dealValues;
    //             }
    //             else {
    //                 if (formDatas.length > 0) {
    //                     for (let i = 0; i < formDatas.length; i += 1) {
    //                         if (formDatas[i].total !== undefined)
    //                             sum += 1 * formDatas[i].total;
    //                     }
    //                 }
    //                 else if (!isservicesDataValid) {
    //                     sum = 1 * dealValues;
    //                 }
    //                 if (servicesData.length > 0) {
    //                     for (let i = 0; i < servicesData.length; i += 1) {
    //                         if (servicesData[i].serviceLineCost !== undefined)
    //                             sum += 1 * servicesData[i].serviceLineCost;
    //                     }
    //                 }
    //                 else if (!isFormDataValid) {
    //                     sum = 1 * dealValues;
    //                 }
    //             }
    //         }
    //         else if (overAllData?.subtype === "Request for Proposal" || overAllData?.subtype === "Others") {
    //             sum = 1 * dealValues;
    //         }
    //     }
    //     if (overAllData?.subtype === "Staff Augmentation") {
    //         for (let i = 0; i < roleData.length; i += 1) {
    //             if (roleData[i].totalValue !== undefined)
    //                 sum += 1 * roleData[i].totalValue;
    //         }
    //     }
    //     if (overAllData?.discountPercentage !== "0" && overAllData?.discountPercentage !== 0 && overAllData?.discountPercentage !== "" && overAllData?.discountPercentage !== null && overAllData?.discountPercentage !== undefined) {
    //         totalsum = sum * (1 - Number(overAllData?.discountPercentage) / 100)
    //     }
    //     else {
    //         totalsum = sum
    //     }
    //     if (overAllData?.winProbability !== undefined && overAllData?.winProbability !== "") {
    //         if (totalSumValues?.dealValue) {
    //             const dValue = 1 * totalSumValues.dealValue;
    //             Fvalue = dValue * (1 * overAllData.winProbability / 100)
    //         }
    //     }
    //     if (pipeLineField !== "Won") {
    //         if (overAllData?.expectedDealLength !== undefined && overAllData?.expectedDealLength !== "") {
    //             if (totalSumValues?.dealValue) {
    //                 const dValue = 1 * totalSumValues.dealValue;
    //                 profit = dValue * (1 * overAllData.expectedDealLength / 100)
    //             }
    //         }
    //     }
    //     if (pipeLineField === "Won") {
    //         if (changeDealMargin2 !== undefined && changeDealMargin2 !== "") {
    //             if (totalSumValues?.dealValue) {
    //                 const dValue = 1 * totalSumValues.dealValue;
    //                 profit = dValue * (1 * changeDealMargin2 / 100)
    //             }
    //         }
    //     }
    //     setTotalSumValues({
    //         dealValue: totalsum?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
    //         grossdealValue: sum?.toFixed(CurencyDecimalPlace),
    //         forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
    //         dealprofit: profit?.toFixed(CurencyDecimalPlace)
    //     })
    // }
    useEffect(() => {
        if (popupType === "Update") {
            setDealCalculation(dealDataSet)
        }
    }, [popupType])
    // useEffect(() => {
    //     if (popupType === "Update") {
    //         if (overAllData) {
    //             totalCalculation()
    //         }
    //     }
    // }, [popupType, changeDealMargin2, overAllData, totalSumValues.dealValue])
    const [edit] = useState(true)
    const leadSharedProps = useMemo(() => ({
        form, edit, pipeLineField, disabledDate, dealTypeField, defaultCurrency, dealFieldConfig
    }), [form, edit, pipeLineField, disabledDate, dealTypeField, defaultCurrency, dealFieldConfig]);
    return (
        <>
            <Modal
                title={popupType === "Update" ? "Update Deal" : "Create Deal"}
                open={Popup}
                onCancel={handleClose}
                width={700}
                maskClosable={false}
                footer={[
                    <div>
                        <>
                            <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose} disabled={disabled}>
                                <FeatherIcon icon="x" /> Cancel
                            </Button>
                            <Button htmlType="submit" size="small" onClick={() => form.submit()} className='button_colors' dissbled={disabled || deleteClick} loading={deleteClick}>
                                {!deleteClick && <FeatherIcon icon="save" />} Save
                            </Button>
                        </>
                    </div>
                ]}
            >
                <AddUser>
                    <div className="user-info-form">
                        <Form style={{ width: '100%' }} form={form} name="info" colon={false}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed} >
                            <BasicFormWrapper>
                                <VerticalFormStyleWrap>
                                    <div className="add-product-block">
                                        <Row gutter={15}>
                                            <Col xs={24}>
                                                <div className="add-product-content">
                                                    {popupType === "Update" &&
                                                        <>
                                                            <CommonFormFields
                                                                groups={selectedGroup}
                                                                customFields={customFields}
                                                                specialFields={{}}
                                                                sharedProps={leadSharedProps}
                                                                optionsMap={optionsMap}
                                                                fromDeal="Yes"
                                                            /></>
                                                        // <Row gutter={30} style={{ padding: "0px 20px" }}>

                                                        //     {pipeLineField === "won" &&
                                                        //         <>
                                                        //             <Col span={12} style={{ marginBottom: 20 }}>
                                                        //                 <Form.Item label="Actual Closure Date" name="actualclosureDate"
                                                        //                     id="actualclosureDate"
                                                        //                     rules={pipeLineField === "Won" && dealTypes !== "Empanelment" ? [{ required: true, message: 'Please select actual closure date', }] : [{ required: false }]}
                                                        //                 ><DatePicker
                                                        //                         onChange={actualclosuredateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate}
                                                        //                     />
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //             <Col span={12} style={{ marginBottom: 20 }} >
                                                        //                 <Form.Item label="Actual Deal Margin" name="actualDealMargin"
                                                        //                     id="actualDealMargin" rules={pipeLineField === "Won" && dealTypes !== "Empanelment" ? [{ required: true, message: 'Please select actual deal margin' }, {
                                                        //                         validator: async (_, value) => {
                                                        //                             if (value === undefined || value === null || value === '') {
                                                        //                                 return Promise.resolve();
                                                        //                             }
                                                        //                             // Strict numeric check (digits with optional 1 dot)
                                                        //                             const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                        //                             if (!basicNumberCheck.test(value)) {
                                                        //                                 return Promise.reject(new Error('Please enter a valid number'));
                                                        //                             }

                                                        //                             // Check decimal places (must be ≤ 2)
                                                        //                             const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                        //                             if (!decimalRegex.test(value)) {
                                                        //                                 return Promise.reject(
                                                        //                                     new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                        //                                 );
                                                        //                             }

                                                        //                             const num = Number(value); // Now it's guaranteed to be a proper number

                                                        //                             if (num < 0 || num > 100) {
                                                        //                                 return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                        //                             }

                                                        //                             return Promise.resolve();
                                                        //                         }

                                                        //                     }] : [{ required: false }]}>
                                                        //                     <Input prefix="%" placeholder='Enter Actual Deal Margin' onChange={(e) => setChangeDealMargin2(e.target.value)} />
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //             <Col span={12} style={{ marginBottom: 20 }}>
                                                        //                 <Form.Item label="Deal Won Reason" name="dealWonreasons"
                                                        //                     id="dealWonreasons"
                                                        //                 >
                                                        //                     <Select style={{ width: '100%' }} placeholder="Select Deal Won Reasons">
                                                        //                         {dealWon}
                                                        //                     </Select>
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //         </>
                                                        //     }
                                                        //     {pipeLineField === "lost" &&
                                                        //         <>
                                                        //             <Col span={12} style={{ marginBottom: 20 }}>
                                                        //                 <Form.Item label="Deal Lost Date" name="dealLostDate"
                                                        //                     id="dealLostDate"
                                                        //                     rules={pipeLineField === "Lost" && dealTypes !== "Empanelment" ? [{ required: true, message: 'Please select deal lost date', }] : [{ required: false }]}>
                                                        //                     <DatePicker onChange={dealLostDateChange}
                                                        //                         format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                        //                         disabledDate={disabledDate} />
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //             <Col span={12} style={{ marginBottom: 20 }}>
                                                        //                 <Form.Item label="Deal Lost Reason" name="deallostReasons" id="deallostReasons" >
                                                        //                     <Select style={{ width: '100%' }} placeholder="Select Deal Lost Reasons">
                                                        //                         {dealLose}
                                                        //                     </Select>
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //         </>
                                                        //     }
                                                        //     {(pipeLineField === "onhold") &&
                                                        //         <>
                                                        //             <Col span={12} style={{ marginBottom: 20 }}>
                                                        //                 <Form.Item label="Deal On-Hold Date" name="dealonholdDate"
                                                        //                     id="dealonholdDate"
                                                        //                     rules={pipeLineField === "onhold" && dealTypes !== "Empanelment" ? [{ required: true, message: 'Please select deal on-hold date', }] : [{ required: false }]}>
                                                        //                     <DatePicker onChange={dealonholdDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //             <Col span={12} style={{ marginBottom: 20 }}>
                                                        //                 <Form.Item label="Deal Restart Date" name="dealrestartDate"
                                                        //                     id="dealrestartDate" rules={[
                                                        //                         ({ getFieldValue }) => ({
                                                        //                             validator(_, value) {
                                                        //                                 const dealonholdDate = getFieldValue('dealonholdDate');

                                                        //                                 if (!value || !dealonholdDate || value >= dealonholdDate) {
                                                        //                                     return Promise.resolve();
                                                        //                                 }

                                                        //                                 return Promise.reject(new Error('Deal Restart Date must be after Deal onhold Date'));
                                                        //                             },
                                                        //                         }),]}>
                                                        //                     <DatePicker onChange={dealrestartDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //             <Col span={12} style={{ marginBottom: 20 }}>
                                                        //                 <Form.Item label="Deal On-Hold Reason" name="dealonHoldReason" id="dealonHoldReason" >
                                                        //                     <Select style={{ width: '100%' }} placeholder="Select Deal On-Hold Reasons">
                                                        //                         {dealOnHold}
                                                        //                     </Select>
                                                        //                 </Form.Item>
                                                        //             </Col>
                                                        //         </>}
                                                        // </Row>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </VerticalFormStyleWrap>
                            </BasicFormWrapper>
                        </Form>
                    </div>
                </AddUser>
            </Modal >
        </>
    );
};

Popup.propTypes = {
    Popup: PropTypes.bool.isRequired,
    setPopup: PropTypes.func.isRequired,
    GetCallback: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    Id: PropTypes.number.isRequired,
    // old: PropTypes.number.isRequired,
    // pipelineId: PropTypes.number.isRequired,
    pipeline: PropTypes.string.isRequired,
    dealTypes: PropTypes.string.isRequired,
    dealDataSet: PropTypes.object.isRequired,
    dealInitialDataset: PropTypes.object.isRequired,
    defaultCurrency: PropTypes.object.isRequired,
    successMessage: PropTypes.func.isRequired,
    ApprovalMessage: PropTypes.string.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    setErrorData: PropTypes.func.isRequired,
    setIsModalVisible1: PropTypes.func.isRequired,
    filteredGruop: PropTypes.array.isRequired,
    customFields: PropTypes.object.isRequired,
    optionsMap: PropTypes.object.isRequired,
};

export default Popup;